import { Component, OnInit } from '@angular/core';
import { CockpitService } from '../../../service/cockpit/cockpit.service';
import { SummaryTableItem } from '../summary-table/summary-table.component';

@Component({
  selector: 'app-approval-summary',
  templateUrl: './approval-summary.component.html'
})
export class ApprovalSummaryComponent implements OnInit {

  public approvalSummaryItems: SummaryTableItem[] = [];

  constructor(private cockpitService: CockpitService) { }

  ngOnInit() {
    this.getApprovalSummaryItems();
  }

  getApprovalSummaryItems(gcs: string[] = []) {
    this.cockpitService.getApprovalSummary(gcs).subscribe(result => {
			if (result.Success) {
				this.approvalSummaryItems = result.Result;
			}
		}, error => {
			console.log(error);
		});
  }
}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/approval-summary/approval-summary.component.ts